import { cx } from '@emotion/css';
import React from 'react';
import { ix } from '../../../utils/ix';
import { Button } from '../../atoms';
import { useWizardNavigationSectionStyles } from './WizardNavigationSections.styles';
export function WizardNavigationSections(props) {
    const classes = useWizardNavigationSectionStyles();
    const handleCancel = () => {
        props.onCancel();
    };
    const handleCustomAction = () => {
        var _a;
        (_a = props.onCustomAction) === null || _a === void 0 ? void 0 : _a.call(props);
    };
    const handleSaveAndContinue = () => {
        props.onSaveAndContinue();
    };
    return (React.createElement("div", { id: props.id, className: cx(props.className, classes.container) },
        React.createElement(Button, { id: ix(props.id, 'cancel-btn'), color: "primary", variant: "outlined", onClick: handleCancel }, "Cancel"),
        React.createElement("div", null,
            props.customActionEnabled && (React.createElement(Button, { id: ix(props.id, 'custom-btn'), className: classes.customBtn, color: "primary", variant: "outlined", onClick: handleCustomAction, disabled: props.customActionIsDisabled }, props.customActionText)),
            React.createElement(Button, { id: ix(props.id, 'save-btn'), color: "primary", variant: "contained", onClick: handleSaveAndContinue, disabled: props.saveAndContinueIsDisabled }, props.saveAndContinueAlternateText || 'Save & Continue'))));
}
//# sourceMappingURL=WizardNavigationSections.js.map